import { resizeObservers } from '../ResizeObserverController';
const hasSkippedObservations = () => {
    return resizeObservers.some((ro) => ro.skippedTargets.length > 0);
};
export { hasSkippedObservations };
